import React from "react";
import { HoloPlayerCard } from "../HoloPlayerCard";

/**
 * YourCardPreview — holo card preview on the dashboard.
 * Spreads the full user object so any visual fields (card_bg, top_games,
 * teams, badges, …) reach HoloPlayerCard without a per-field whitelist.
 */
export function YourCardPreview({ user }) {
  return <HoloPlayerCard p={user} isSelf />;
}
